import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/ImageAddFilled.tsx
import React from "react";
var SvgImageAddFilled, ImageAddFilled_default;
var init_ImageAddFilled = __esm({
  "src/icons/ImageAddFilled.tsx"() {
    SvgImageAddFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Zm.008-12c.548 0 .992.445.992.993v9.349A5.99 5.99 0 0 0 20 13V5H4l.001 14 9.292-9.293a.999.999 0 0 1 1.32-.084l.094.085 3.545 3.55a6.003 6.003 0 0 0-3.91 7.743L2.992 21A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016ZM8 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
        }
      )
    );
    ImageAddFilled_default = SvgImageAddFilled;
  }
});

export {
  ImageAddFilled_default,
  init_ImageAddFilled
};
